import { render } from "./Load.vue?vue&type=template&id=262f52af&scoped=true"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"

import "./Load.vue?vue&type=style&index=0&id=262f52af&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262f52af"]])

export default __exports__